import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface PaintingSidingWallFinishProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const PaintingSidingWallFinish: React.FC<PaintingSidingWallFinishProps> = ({
    required = false,
    propertyGuid,
    isReview = false,
}) => {
    const [paintingSidingWallFinish, set_paintingSidingWallFinish] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Exterior Structure']?.['Painting, Siding, Wall Finish']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Exterior Structure': { ...b.values?.['Exterior Structure'], 'Painting, Siding, Wall Finish': [b.values?.['Exterior Structure']?.['Painting, Siding, Wall Finish']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Painting, Siding, Wall Finish';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(paintingSidingWallFinish)}
                />
            ) : (
                <MoneyBox
                    id={'paintingSidingWallFinish'}
                    allowNegative={false}
                    value={paintingSidingWallFinish}
                    onChange={(value) => set_paintingSidingWallFinish(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
